import { Resource } from './resource';
import { RenderedTimelineEvent } from '../components/CaptureViewer/ViewerPlaybackControls';

export type RenderedTimelineEventWithTrackOffset = RenderedTimelineEvent & {
  secondsInTrack: number;
};

export type EventTimelineState = {
  pendingChanges: Array<RenderedTimelineEventWithTrackOffset>;
};

export enum EventTimelineActionTypes {
  EVENT_TIMELINE_ADD_CHANGE = 'EVENT_TIMELINE_ADD_CHANGE',
  EVENT_TIMELINE_CLEAR_CHANGES = 'CLEAR_CHANGES',
  EVENT_TIMELINE_UPDATE_ANNOTATION_EVENTS = 'UPDATE_ANNOTATION_EVENTS',
}

export type EventTimelineAction =
  | {
      type: EventTimelineActionTypes.EVENT_TIMELINE_ADD_CHANGE;
      change: RenderedTimelineEventWithTrackOffset;
    }
  | {
      type: EventTimelineActionTypes.EVENT_TIMELINE_CLEAR_CHANGES;
    }
  | {
      type: EventTimelineActionTypes.EVENT_TIMELINE_UPDATE_ANNOTATION_EVENTS;
      changes: Array<RenderedTimelineEventWithTrackOffset>;
    };
